import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { emptyInputLength } from '@/components/ShippingInfo/LiveShippingInfo/components/ShippingPickupOptions/components/LiveShipping/components/CustomShippingRateModal/components/LocationForm/components/PostalCode/EnterPostalCode.constants';
import { LIVE_SHIPPING_METHOD_TRANSLATION_KEY } from '@/components/ShippingInfo/LiveShippingInfo/components/ShippingPickupOptions/components/LiveShipping/LiveShippingMethodRow.constants';
import { TextInput } from '@liveauctioneers/hammer-ui-core/textInput';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

export type EnterPostalCodeProps = {
    countryCode: string;
    isLoading: boolean;
    onChangePostalCode: (newPostalCode: string) => void;
    onSubmit: () => void;
};

const EnterPostalCode = ({ countryCode, isLoading, onChangePostalCode, onSubmit }: EnterPostalCodeProps) => {
    const { formatMessage } = useIntl();
    const [postalCode, setPostalCode] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const onChange = useCallback(
        (newPostalCode: string) => {
            onChangePostalCode(newPostalCode);
            setPostalCode(newPostalCode);
            setSubmitted(false);
        },
        [onChangePostalCode]
    );

    const onSubmitEstimate = useCallback(() => {
        onSubmit();
        setSubmitted(true);
    }, [onSubmit]);

    const hasProperLength = postalCode.length > emptyInputLength;
    const hasError = submitted && !hasProperLength;
    const isUS = countryCode === 'US';

    return (
        <>
            {isUS ? (
                <TextInput
                    aria-label="Postal Code"
                    hasError={hasError}
                    labelText={formatMessage({
                        id: `${LIVE_SHIPPING_METHOD_TRANSLATION_KEY}.rateModal.usPostalCodeLabel`,
                    })}
                    onChange={(event) => onChange(event.currentTarget.value)}
                />
            ) : (
                <TextInput
                    aria-label="Postal Code"
                    hasError={hasError}
                    labelText={formatMessage({
                        id: `${LIVE_SHIPPING_METHOD_TRANSLATION_KEY}.rateModal.postalCodeLabel`,
                    })}
                    onChange={(event) => onChange(event.currentTarget.value)}
                />
            )}
            <StyledSubmitButton
                disabled={!hasProperLength || postalCode.length === emptyInputLength}
                loading={isLoading}
                onClick={onSubmitEstimate}
            >
                {formatMessage({
                    id: `${LIVE_SHIPPING_METHOD_TRANSLATION_KEY}.rateModal.submit`,
                })}
            </StyledSubmitButton>
        </>
    );
};

export default EnterPostalCode;

const StyledSubmitButton = styled(Button)`
    margin-left: auto;
    margin-right: auto;
`;
